import { useContext, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import NoVehicles from 'public/static/images/srp/NoVehicles.svg';
import { colors } from 'components/styles/variables';
import SrpEventContext from 'contexts/SrpEventContext';
import { SourcePages } from 'lib/EventSchema';

const NoResultsView = (): JSX.Element => {
  const { t } = useTranslation();
  const [scrollY, setScrollY] = useState(0);
  const { sourcePage } = useContext(SrpEventContext);

  const getScrollPosition = (): { [key: string]: string } => ({
    transform: `translateY(${scrollY}px`,
  });

  const handleScroll = (): void => {
    if (window.scrollY > 250) setScrollY(window.scrollY - 250);
    else setScrollY(0);
  };

  useLayoutEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div
        className="container"
        style={sourcePage === SourcePages.SeoSrp ? {} : getScrollPosition()}
      >
        <div className="icon" />
        <div className="header">{t('srp.noListings.header')}</div>
        <div className="subtext">{t('srp.noListings.subText')}</div>
        <div className="spacer" />
      </div>
      <style jsx>
        {`
          .spacer {
            width: 90%;
            height: 12px;
          }

          .container {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding-top: 60px;
            align-items: center;
            border-top: 1px solid ${colors.G2};
            border-bottom: 1px solid ${colors.G2};
          }

          @media (min-width: 850px) {
            .container {
              max-width: 1038px;
              width: 100%;
            }
          }

          .icon {
            background-image: url('${NoVehicles}');
            background-repeat: no-repeat;
            background-size: cover;
            width: 52px;
            height: 52px;
          }

          .header {
            font-weight: bold;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
            letter-spacing: 0.2px;
            color: ${colors.BLACK};
            width: 280px;
            margin: 16px 0 8px 0;
          }

          .subtext {
            font-size: 16px;
            line-height: 24px;
            text-align: center;
            letter-spacing: 0.2px;
            color: ${colors.G3};
            width: 280px;
            margin-bottom: 60px;
          }
        `}
      </style>
    </>
  );
};

export default NoResultsView;
